import { useFormContext } from "react-hook-form";
import { cn } from "ui";
import { useField } from "../hooks/useField";
import { useFormFieldContext } from "./FormField";

interface TextAreaFormField {
  rows?: number;
  placeholder?: string;
}

export function TextAreaFormField({
  rows = 5,
  placeholder,
}: TextAreaFormField) {
  const {
    name,
    disabled,
    readOnly,
    required,
    defaultValue,
    validation,
    customValidation,
    descriptionId,
    errorMessageId,
    shouldUnregister,
  } = useFormFieldContext();

  const { ref, value, onChange, onBlur, error } = useField({
    name,
    defaultValue,
    validation,
    customValidation,
    shouldUnregister,
  });

  const { setValue } = useFormContext();

  return (
    <textarea
      id={name}
      ref={ref}
      name={name}
      value={value || ""}
      onChange={onChange}
      onBlur={() => {
        setValue(name, value?.trim(), { shouldValidate: true });
        onBlur();
      }}
      className={cn(
        "block w-full rounded-md border border-foundations-bold bg-foundations-default text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:outline-none focus:ring-info-bold sm:text-sm",
        error &&
          "border-danger-bold focus:border-danger-bold focus:ring-danger-bold"
      )}
      rows={rows}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      required={required}
      aria-describedby={
        !error ? `${descriptionId}` : `${descriptionId} ${errorMessageId}`
      }
      aria-invalid={!!error}
    />
  );
}
